import http from "@/util/request.js";
let SSOID= $cookies.get("SSOID")
// 消息列表
export const sysMessageList = (params) => http({
    method: "get",
    url: "/apis/hmcsFinance/v1/sysMessage/list?SSOID="+SSOID,
    params:params
})
// 是否存在未读消息
export const checkToRead = (params) => http({
    method: "get",
    url: "/apis/hmcsFinance/v1/sysMessage/checkToRead?SSOID="+SSOID,
    params:params
})

//出库-根据id选择物料列表
export const matterAbout = (params) => http({
    method: "get",
    url: "/apis/hmcsFinance/v1/matterOut/matterList?SSOID="+SSOID,
    params:params
})
// 物料属性
export const matterBute = (params) => http({
    method: "get",
    url: "/apis/hmcsFinance/sku/listType?SSOID="+SSOID,
    params:params
})